module.exports = __webpack_public_path__ + "media/images/fixed-15f776eb644dab7292fb8eaad8c0395b.png";